import React from "react";
import {useTranslation} from "react-i18next";

import StationCol from "../../../components/columns/StationCol";
import AclTable from "../../../components/AclTable";
import Card from "@mui/material/Card";


export const StationPermissions = ({user}) => {
    const {t} = useTranslation("user");

    const isPermissionDisabled = (station, permission) => {
        if (permission === 'mod1:write') {
            return station.acceptMod1 === false;
        } else if (permission === 'mod23:write') {
            return station.acceptMod23 === false;
        }
        else{
            return true;
        }
    }

    return <Card sx={{p: 2}}>
        <AclTable title={t('cardPermissions.stationTitle')}
                  principalType={"user"}
                  principalId={user.id}
                  resourcesType={"station"}
                  permissions={['mod1:write', 'mod23:write']}
                  entityHeader={t('cardPermissions.table.station')}
                  renderEntityCol={(station) => <StationCol station={station}/>}
                  multipleCheck
                  entitySortFieldName="code"
                  isPermissionDisabled={isPermissionDisabled}
        />
    </Card>
}